module.exports = __webpack_public_path__ + "static/img/login.d2734e4e.png";